export default __webpack_public_path__ + "static/media/tutorial2-7.27e5bc93.png";